import React, { useState, useEffect } from 'react';
import Slider from '../components/Slider';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import EmbedSection from '../components/EmbedSection';
import { useAuth } from '../context/AuthContext';
import homePageService from '../services/homePageService';

const HomePage = () => {
  const { isSuperAdmin, user, isAuthenticated } = useAuth();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [isTextModalOpen, setIsTextModalOpen] = useState(false);
  const [currentTextSection, setCurrentTextSection] = useState(null);

  const [sideImages, setSideImages] = useState({
    welcome: "/bayrak.png",
    discover: "/bayrak.png",
    cultural: "/bayrak.png"
  });

  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [currentImageSection, setCurrentImageSection] = useState(null);

  // Loading state for homepage content
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Slider verileri için state
  const [sliderData, setSliderData] = useState([
    {
      id: 1,
      image: '/bayrak.png',
      url: 'https://example.com/slider1'
    },
    {
      id: 2,
      image: '/bayrak.png',
      url: 'https://example.com/slider2'
    },
    {
      id: 3,
      image: '/bayrak.png',
      url: 'https://example.com/slider3'
    }
  ]);

  // Kutular için state
  const [boxData, setBoxData] = useState([
    { id: 1, image: '/bayrak.png', url: 'https://example.com/1' },
    { id: 2, image: '/bayrak.png', url: 'https://example.com/2' },
    { id: 3, image: '/bayrak.png', url: 'https://example.com/3' },
    { id: 4, image: '/bayrak.png', url: 'https://example.com/4' },
    { id: 5, image: '/bayrak.png', url: 'https://example.com/5' },
    { id: 6, image: '/bayrak.png', url: 'https://example.com/6' },
    { id: 7, image: '/bayrak.png', url: 'https://example.com/7' },
    { id: 8, image: '/bayrak.png', url: 'https://example.com/8' }
  ]);

  // Metinler için state
  const [textData, setTextData] = useState({
    welcome: {
      title: "Zaman Bilimi'ne Hoş Geldiniz",
      description: "Türk tarihini ve kültürünü keşfetmek için en iyi platform. Zaman çizelgelerimiz ile tarihi olayları, önemli kişileri ve kültürel gelişmeleri interaktif bir şekilde inceleyebilirsiniz.",
      buttonUrl: "https://example.com/welcome"
    },
    discover: {
      title: "Tarihi Keşfedin",
      description: "Türk tarihinin önemli dönüm noktalarını, savaşları, antlaşmaları ve kültürel gelişmeleri interaktif zaman çizelgelerimizde keşfedin.",
      buttonUrl: "https://example.com/discover"
    },
    cultural: {
      title: "Kültürel Miras",
      description: "Türk kültürünün zengin mirasını, sanat eserlerini, mimari yapıları ve gelenekleri keşfedin.",
      buttonUrl: "https://example.com/cultural"
    },
    explore: {
      title: "Zaman Çizelgelerini Keşfedin",
      description: "Zaman Bilimi ile oluşturulmuş etkileyici zaman çizelgelerini inceleyin",
      buttonUrl: "https://example.com/explore"
    }
  });

  // Load homepage content from backend
  useEffect(() => {
    const loadHomePageContent = async () => {
      try {
        setLoading(true);
        const content = await homePageService.getHomePageContent();

        if (content.sliderData) setSliderData(content.sliderData);
        if (content.boxData) setBoxData(content.boxData);
        if (content.textData) setTextData(content.textData);
        if (content.sideImages) setSideImages(content.sideImages);

        setError(null);
      } catch (error) {
        console.error('Error loading homepage content:', error);
        setError('Failed to load homepage content');
      } finally {
        setLoading(false);
      }
    };

    loadHomePageContent();
  }, []);

  const handleImageChange = (id) => {
    const image = boxData.find(img => img.id === id);
    setCurrentImage(image);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setCurrentImage(null);
  };

  const handleModalSubmit = async (newUrl) => {
    const newBoxData = boxData.map(img => {
      if (img.id === currentImage.id) {
        return { ...img, url: newUrl };
      }
      return img;
    });
    setBoxData(newBoxData);

    // Save to backend if user is super admin
    if (isSuperAdmin) {
      try {
        await homePageService.updateHomePageContent({
          boxData: newBoxData
        });
        console.log('Box URL updated:', currentImage.id);
      } catch (error) {
        console.error('Error updating box URL:', error);
        // Revert the change on error
        setBoxData(boxData);
      }
    }

    handleModalClose();
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async (event) => {
        const newBoxData = boxData.map(img => {
          if (img.id === currentImage.id) {
            return { ...img, image: event.target.result };
          }
          return img;
        });
        setBoxData(newBoxData);

        // Save to backend if user is super admin
        if (isSuperAdmin) {
          try {
            await homePageService.updateHomePageContent({
              boxData: newBoxData
            });
            console.log('Box image updated:', currentImage.id);
          } catch (error) {
            console.error('Error updating box image:', error);
            // Revert the change on error
            setBoxData(boxData);
          }
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleTextEdit = (section) => {
    setCurrentTextSection(section);
    setIsTextModalOpen(true);
  };

  const handleTextSave = () => {
    setIsTextModalOpen(false);
    setCurrentTextSection(null);
  };

  const handleImageSectionEdit = (section) => {
    setCurrentImageSection(section);
    setIsImageModalOpen(true);
  };

  const handleImageSectionUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const newSideImages = {
          ...sideImages,
          [currentImageSection]: reader.result
        };
        setSideImages(newSideImages);

        // Save to backend if user is super admin
        if (isSuperAdmin) {
          try {
            await homePageService.updateHomePageContent({
              sideImages: newSideImages
            });
            console.log('Side image updated:', currentImageSection);
          } catch (error) {
            console.error('Error updating side image:', error);
            // Revert the change on error
            setSideImages(sideImages);
          }
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleTextChange = async (section, field, value) => {
    const newTextData = {
      ...textData,
      [section]: {
        ...textData[section],
        [field]: value
      }
    };
    setTextData(newTextData);

    // Save to backend if user is super admin
    if (isSuperAdmin) {
      try {
        await homePageService.updateHomePageContent({
          textData: newTextData
        });
        console.log('Metin güncellendi:', section, field);
      } catch (error) {
        console.error('Metin güncellenirken hata:', error);
        // Revert the change on error
        setTextData(textData);
      }
    }
  };

  // Slider düzenleme fonksiyonları - Updated to handle full slider data
  const handleSliderImageChange = async (id, file) => {
    const reader = new FileReader();
    reader.onloadend = async () => {
      const newSliderData = sliderData.map(slide =>
        slide.id === id ? { ...slide, image: reader.result } : slide
      );
      setSliderData(newSliderData);

      // Save to backend if user is super admin
      if (isSuperAdmin) {
        try {
          await homePageService.updateHomePageContent({
            sliderData: newSliderData
          });
          console.log('Slider resmi güncellendi:', id);
        } catch (error) {
          console.error('Slider resmi güncellenirken hata:', error);
          // Revert the change on error
          setSliderData(sliderData);
        }
      }
    };
    reader.readAsDataURL(file);
  };

  const handleSliderUrlChange = async (id, newUrl) => {
    const newSliderData = sliderData.map(slide =>
      slide.id === id ? { ...slide, url: newUrl } : slide
    );
    setSliderData(newSliderData);

    // Save to backend if user is super admin
    if (isSuperAdmin) {
      try {
        await homePageService.updateHomePageContent({
          sliderData: newSliderData
        });
        console.log('Slider URL güncellendi:', id);
      } catch (error) {
        console.error('Slider URL güncellenirken hata:', error);
        // Revert the change on error
        setSliderData(sliderData);
      }
    }
  };

  // New function to handle complete slider data update
  const handleSliderDataUpdate = async (newSliderData) => {
    setSliderData(newSliderData);

    // Save to backend if user is super admin
    if (isSuperAdmin) {
      try {
        await homePageService.updateHomePageContent({
          sliderData: newSliderData
        });
        console.log('Slider verileri güncellendi');
      } catch (error) {
        console.error('Slider verileri güncellenirken hata:', error);
        // Revert the change on error
        setSliderData(sliderData);
      }
    }
  };

  // Kutu düzenleme fonksiyonları
  const handleBoxImageChange = async (id, file) => {
    const reader = new FileReader();
    reader.onloadend = async () => {
      const newBoxData = boxData.map(box =>
        box.id === id ? { ...box, image: reader.result } : box
      );
      setBoxData(newBoxData);

      // Save to backend if user is super admin
      if (isSuperAdmin) {
        try {
          await homePageService.updateHomePageContent({
            boxData: newBoxData
          });
          console.log('Kutu resmi güncellendi:', id);
        } catch (error) {
          console.error('Kutu resmi güncellenirken hata:', error);
          // Revert the change on error
          setBoxData(boxData);
        }
      }
    };
    reader.readAsDataURL(file);
  };

  const handleBoxUrlChange = async (id, newUrl) => {
    const newBoxData = boxData.map(box =>
      box.id === id ? { ...box, url: newUrl } : box
    );
    setBoxData(newBoxData);

    // Save to backend if user is super admin
    if (isSuperAdmin) {
      try {
        await homePageService.updateHomePageContent({
          boxData: newBoxData
        });
        console.log('Kutu URL güncellendi:', id);
      } catch (error) {
        console.error('Kutu URL güncellenirken hata:', error);
        // Revert the change on error
        setBoxData(boxData);
      }
    }
  };

  // Show loading screen while loading content
  if (loading) {
    return (
      <div className="min-h-screen flex flex-col">
        <Navigation />
        <main className="flex-grow bg-gradient-to-br from-zinc-50 to-gray-100 flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600 mx-auto"></div>
            <p className="mt-4 text-gray-600">İçerik yükleniyor...</p>
          </div>
        </main>
      </div>
    );
  }

  // Show error screen if there's an error
  if (error) {
    return (
      <div className="min-h-screen flex flex-col">
        <Navigation />
        <main className="flex-grow bg-gradient-to-br from-zinc-50 to-gray-100 flex items-center justify-center">
          <div className="text-center">
            <div className="text-red-600 mb-4">
              <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <p className="text-red-600 font-semibold">Hata: {error}</p>
            <button
              onClick={() => window.location.reload()}
              className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Yeniden Dene
            </button>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-grow bg-gradient-to-br from-zinc-50 to-gray-100">
        <Slider
          slides={sliderData}
          onImageChange={handleSliderImageChange}
          onUrlChange={handleSliderUrlChange}
          onSliderDataUpdate={handleSliderDataUpdate}
        />

        {/* Resim Galerisi */}
        <div className="container mx-auto px-4 py-3 md:py-4">
          <div className="max-w-6xl mx-auto">
            {/* Başlık ve Açıklama */}
            <div className="text-center mb-8 relative group">
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">
                {textData.explore.title}
              </h2>
              <p className="text-sm md:text-base text-gray-600">
                {textData.explore.description}
              </p>
              {isSuperAdmin && (
                <button
                  onClick={() => handleTextEdit('explore')}
                  className="absolute top-2 right-2 bg-blue-600 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                  </svg>
                </button>
              )}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-16">
              {boxData.map((image) => (
                <div key={image.id} className="bg-white rounded-lg shadow-md overflow-hidden h-[120px] sm:h-[140px] md:h-[160px] hover:shadow-lg transition-shadow duration-300 relative group">
                  <a href={image.url} target="_blank" rel="noopener noreferrer" className="block w-full h-full">
                    <img
                      src={image.image}
                      alt="Timeline Image"
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </a>
                  {isSuperAdmin && (
                    <button
                      onClick={() => handleImageChange(image.id)}
                      className="absolute top-2 right-2 bg-blue-600 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                      </svg>
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Embed Bölümü */}
        <EmbedSection />

        {/* Modal */}
        {isModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-lg font-bold mb-4">Resim ve URL Düzenle</h3>

              {/* Resim Yükleme Alanı */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Resim Yükle
                </label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  className="block w-full text-sm text-gray-500
                    file:mr-4 file:py-2 file:px-4
                    file:rounded-full file:border-0
                    file:text-sm file:font-semibold
                    file:bg-blue-50 file:text-blue-700
                    hover:file:bg-blue-100"
                />
              </div>

              {/* URL Giriş Alanı */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  URL
                </label>
                <input
                  type="text"
                  placeholder="Yeni URL"
                  className="border p-2 w-full"
                  defaultValue={currentImage.url}
                />
              </div>

              <div className="flex justify-end">
                <button
                  onClick={() => handleModalSubmit(document.querySelector('input[type="text"]').value)}
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg"
                >
                  Kaydet
                </button>
                <button
                  onClick={handleModalClose}
                  className="ml-2 bg-gray-600 text-white px-4 py-2 rounded-lg"
                >
                  İptal
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Metin Düzenleme Modalı */}
        {isTextModalOpen && currentTextSection && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-2xl mx-4">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-bold">Metin Düzenle</h3>
                <button
                  onClick={() => setIsTextModalOpen(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Başlık
                  </label>
                  <input
                    type="text"
                    value={textData[currentTextSection].title}
                    onChange={(e) => handleTextChange(currentTextSection, 'title', e.target.value)}
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Açıklama
                  </label>
                  <textarea
                    value={textData[currentTextSection].description}
                    onChange={(e) => handleTextChange(currentTextSection, 'description', e.target.value)}
                    rows="4"
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 whitespace-pre-wrap font-mono"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Buton URL'si
                  </label>
                  <input
                    type="url"
                    value={textData[currentTextSection].buttonUrl}
                    onChange={(e) => handleTextChange(currentTextSection, 'buttonUrl', e.target.value)}
                    placeholder="https://example.com"
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>

              <div className="mt-6 flex justify-end space-x-4">
                <button
                  onClick={() => setIsTextModalOpen(false)}
                  className="px-4 py-2 border rounded-md hover:bg-gray-50"
                >
                  İptal
                </button>
                <button
                  onClick={() => setIsTextModalOpen(false)}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                  Kaydet
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="container mx-auto px-4 py-3 md:py-4">
          <div className="max-w-6xl mx-auto">
            {/* Resim ve Metin Alanı */}
            <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-16">
              {/* Resim Alanı */}
              <div className="bg-white rounded-xl shadow-lg overflow-hidden md:col-span-3 h-[200px] md:h-[300px] relative group">
                <img
                  src={sideImages.welcome}
                  alt="Türk Bayrağı"
                  className="w-full h-full object-cover"
                />
                {isSuperAdmin && (
                  <button
                    onClick={() => handleImageSectionEdit('welcome')}
                    className="absolute top-2 right-2 bg-blue-600 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                    </svg>
                  </button>
                )}
              </div>

              {/* Metin Alanı */}
              <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 h-[200px] md:h-[300px] flex flex-col md:col-span-2 relative group">
                <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">
                  {textData.welcome.title}
                </h2>
                <div className="space-y-3 md:space-y-4 flex-grow overflow-y-auto custom-scrollbar">
                  <p className="text-sm md:text-base text-gray-600 whitespace-pre-wrap">
                    {textData.welcome.description}
                  </p>
                </div>
                <div className="mt-auto pt-4">
                  <a
                    href={textData.welcome.buttonUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-3 py-1.5 bg-blue-600 text-white text-xs font-medium rounded-lg hover:bg-blue-700 transition duration-150"
                  >
                    Daha Geniş Bilgi
                    <svg className="w-3 h-3 ml-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </a>
                </div>
                {isSuperAdmin && (
                  <button
                    onClick={() => handleTextEdit('welcome')}
                    className="absolute top-2 right-2 bg-blue-600 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                    </svg>
                  </button>
                )}
              </div>

              {/* İkinci Metin Alanı */}
              <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 h-[200px] md:h-[300px] flex flex-col md:col-span-2 relative group">
                <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">
                  {textData.discover.title}
                </h2>
                <div className="space-y-3 md:space-y-4 flex-grow overflow-y-auto custom-scrollbar">
                  <p className="text-sm md:text-base text-gray-600 whitespace-pre-wrap">
                    {textData.discover.description}
                  </p>
                </div>
                <div className="mt-auto pt-4">
                  <a
                    href={textData.discover.buttonUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-3 py-1.5 bg-blue-600 text-white text-xs font-medium rounded-lg hover:bg-blue-700 transition duration-150"
                  >
                    Daha Geniş Bilgi
                    <svg className="w-3 h-3 ml-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </a>
                </div>
                {isSuperAdmin && (
                  <button
                    onClick={() => handleTextEdit('discover')}
                    className="absolute top-2 right-2 bg-blue-600 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                    </svg>
                  </button>
                )}
              </div>

              {/* İkinci Resim Alanı */}
              <div className="bg-white rounded-xl shadow-lg overflow-hidden md:col-span-3 h-[200px] md:h-[300px] relative group">
                <img
                  src={sideImages.discover}
                  alt="Türk Bayrağı"
                  className="w-full h-full object-cover"
                />
                {isSuperAdmin && (
                  <button
                    onClick={() => handleImageSectionEdit('discover')}
                    className="absolute top-2 right-2 bg-blue-600 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                    </svg>
                  </button>
                )}
              </div>

              {/* Üçüncü Resim Alanı */}
              <div className="bg-white rounded-xl shadow-lg overflow-hidden md:col-span-3 h-[200px] md:h-[300px] relative group">
                <img
                  src={sideImages.cultural}
                  alt="Türk Bayrağı"
                  className="w-full h-full object-cover"
                />
                {isSuperAdmin && (
                  <button
                    onClick={() => handleImageSectionEdit('cultural')}
                    className="absolute top-2 right-2 bg-blue-600 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                    </svg>
                  </button>
                )}
              </div>

              {/* Üçüncü Metin Alanı */}
              <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 h-[200px] md:h-[300px] flex flex-col md:col-span-2 relative group">
                <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">
                  {textData.cultural.title}
                </h2>
                <div className="space-y-3 md:space-y-4 flex-grow overflow-y-auto custom-scrollbar">
                  <p className="text-sm md:text-base text-gray-600 whitespace-pre-wrap">
                    {textData.cultural.description}
                  </p>
                </div>
                <div className="mt-auto pt-4">
                  <a
                    href={textData.cultural.buttonUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-3 py-1.5 bg-blue-600 text-white text-xs font-medium rounded-lg hover:bg-blue-700 transition duration-150"
                  >
                    Daha Geniş Bilgi
                    <svg className="w-3 h-3 ml-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </a>
                </div>
                {isSuperAdmin && (
                  <button
                    onClick={() => handleTextEdit('cultural')}
                    className="absolute top-2 right-2 bg-blue-600 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                    </svg>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Resim Düzenleme Modalı */}
        {isImageModalOpen && currentImageSection && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-2xl mx-4">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-bold">Resim Düzenle</h3>
                <button
                  onClick={() => setIsImageModalOpen(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Mevcut Resim
                  </label>
                  <img
                    src={sideImages[currentImageSection]}
                    alt="Mevcut Resim"
                    className="w-full h-48 object-cover rounded-lg mb-4"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Yeni Resim Yükle
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageSectionUpload}
                    className="block w-full text-sm text-gray-500
                      file:mr-4 file:py-2 file:px-4
                      file:rounded-full file:border-0
                      file:text-sm file:font-semibold
                      file:bg-blue-50 file:text-blue-700
                      hover:file:bg-blue-100"
                  />
                </div>
              </div>

              <div className="mt-6 flex justify-end space-x-4">
                <button
                  onClick={() => setIsImageModalOpen(false)}
                  className="px-4 py-2 border rounded-md hover:bg-gray-50"
                >
                  İptal
                </button>
                <button
                  onClick={() => setIsImageModalOpen(false)}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                  Kaydet
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Özellikler Bölümü */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <h2 className="text-3xl font-bold text-center mb-12">Özellikler</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Harita Entegrasyonu */}
            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-4">
                <div className="p-2 bg-purple-100 rounded-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
              </div>
              <h3 className="text-xl font-semibold mb-2">Harita Bütünleşmesi</h3>
              <p className="text-gray-600">Tarihi olayların konumlarını interaktif haritalar üzerinde görüntüleyin</p>
            </div>

            {/* Zaman Çizelgeleri */}
            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-4">
                <div className="p-2 bg-blue-100 rounded-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                </div>
              </div>
              <h3 className="text-xl font-semibold mb-2">Zaman Çizelgeleri</h3>
              <p className="text-gray-600">Tarihi olayları kronolojik sırayla görüntüleyin</p>
            </div>

            {/* Detaylı Bilgiler */}
            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-4">
                <div className="p-2 bg-green-100 rounded-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
              </div>
              <h3 className="text-xl font-semibold mb-2">Ayrıntılı Bilgiler</h3>
              <p className="text-gray-600">Her olay için kapsamlı bilgi ve kaynaklar</p>
            </div>

            {/* Etkileşimli İçerik */}
            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-4">
                <div className="p-2 bg-red-100 rounded-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                </div>
              </div>
              <h3 className="text-xl font-semibold mb-2">Etkileşimli İçerik</h3>
              <p className="text-gray-600">Görseller ve videolarla zenginleştirilmiş içerikler</p>
            </div>

            {/* Özelleştirme */}
            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-4">
                <div className="p-2 bg-yellow-100 rounded-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                  </svg>
                </div>
              </div>
              <h3 className="text-xl font-semibold mb-2">Özelleştirme</h3>
              <p className="text-gray-600">Kendi zaman çizelgelerinizi oluşturun ve düzenleyin</p>
            </div>

            {/* Paylaşım */}
            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-4">
                <div className="p-2 bg-indigo-100 rounded-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
              </div>
              <h3 className="text-xl font-semibold mb-2">Paylaşım</h3>
              <p className="text-gray-600">Çizelgelerinizi başkalarıyla paylaşın</p>
            </div>

            {/* Arama */}
            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-4">
                <div className="p-2 bg-blue-100 rounded-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
              </div>
              <h3 className="text-xl font-semibold mb-2">Arama</h3>
              <p className="text-gray-600">Gelişmiş arama özellikleri ile içeriklere hızlıca ulaşın</p>
            </div>

            {/* Filtreleme */}
            <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-4">
                <div className="p-2 bg-yellow-100 rounded-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                  </svg>
                </div>
              </div>
              <h3 className="text-xl font-semibold mb-2">Seçim</h3>
              <p className="text-gray-600">İçerikleri dönem, kategori ve etiketlere göre filtreleyin</p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default HomePage; 